import Vue from 'vue';

Vue.component('SearchIndexComponent', require('./components/SearchIndexComponent').default);
Vue.component('SearchDataTable', require('./components/partials/SearchDataTable').default);
Vue.component('SearchBarComponent', require('./components/SearchBarComponent').default);

Vue.component('SearchBarItemPatient', require('./components/partials/SearchBarItemPatient').default);
Vue.component('SearchBarItemConsultant', require('./components/partials/SearchBarItemConsultant').default);
// eslint-disable-next-line vue/component-definition-name-casing
Vue.component('SearchBarItemPharmacy_site', require('./components/partials/SearchBarItemPharmacy_site').default);
